import React from 'react';
import {pdfStyles} from '../styles';
import {Text, View} from "@react-pdf/renderer";

const ThirdTable = ({ tableData }) => {
    return (
        <View style={[pdfStyles.table, pdfStyles.width80]}>
            {/* Добавляем шапку таблицы */}
            <View style={[pdfStyles.tableRow, pdfStyles.bold, pdfStyles.mediumHeight]}>
                <View style={pdfStyles.tableCol20}>
                    <View style={pdfStyles.tableCol}>
                        <Text style={[pdfStyles.center, pdfStyles.centerVertically]}>Период (гг.-гг.)</Text>
                    </View>
                </View>
                <View style={pdfStyles.tableCol55}>
                    <View style={pdfStyles.tableCol}>
                        <Text style={[pdfStyles.center, pdfStyles.centerVertically]}>Наименование образовательного учреждения, город</Text>
                    </View>
                </View>
                <View style={pdfStyles.tableCol25}>
                    <View style={pdfStyles.tableCol}>
                        <Text style={[pdfStyles.center, pdfStyles.centerVertically]}>Специальность</Text>
                    </View>
                </View>
            </View>

            {/* Отображаем строки данных */}
            {tableData.map((item, index) => (
                <View
                    key={index}
                    style={index === 0
                        ? [pdfStyles.tableRow, pdfStyles.mediumHeight]
                        : { ...pdfStyles.tableRow, height: 60 }}>
                    
                    <View style={pdfStyles.tableCol20}>
                        <View style={pdfStyles.tableCol}>
                            <Text style={[pdfStyles.center, pdfStyles.centerVertically]}>{item.periods}</Text>
                        </View>
                    </View>
                    <View style={pdfStyles.tableCol55}>
                        <View style={pdfStyles.tableCol}>
                            <Text style={[pdfStyles.center, pdfStyles.centerVertically]}>{item.instutution}</Text>
                        </View>
                    </View>
                    <View style={pdfStyles.tableCol25}>
                        <View style={pdfStyles.tableCol}>
                            <Text style={[pdfStyles.center, pdfStyles.centerVertically]}>{item.major}</Text>
                        </View>
                    </View>
                </View>
            ))}
        </View>
    );
};

export default ThirdTable;